import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

export function exportSpecPdf({ model, slots, config, casettes, lang = "de" }) {
    const en = lang === "en";
    const L = {
        title: en ? "SPEC SHEET" : "SPEC-BLATT",
        subtitle: en ? `${model} · cable headend (customer-configured)` : `${model} · Kabelkopfstation (kundenkonfiguriert)`,
        created: en ? (d) => `Created on ${d}` : (d) => `Erstellt am ${d}`,
        config: en ? `Configuration: ${slots} cassette slots` : `Bestückung: ${slots} Kassettenplätze`,
        head: en ? ["Slot", "Item no.", "Cassette", "Description"] : ["Slot", "Art.-Nr.", "Kassette", "Beschreibung"],
        empty: en ? "empty" : "frei",
        warranty: en
            ? "4-year warranty on our headends and plug-in cards (DHx base)."
            : "4 Jahre Garantie auf unsere Kopfstationen und Steckkarten (DHx-Basis).",
        footer: en
            ? "Müller Satelliten- und Antennentechnik GmbH · Barthelweiher 14 · 91334 Hemhofen · Germany\nTel. +49 (0) 9195 / 9404-0 · Fax +49 (0) 9195 / 9404-40 · vertrieb@satmueller.de\nConfiguration created with the configurator on our website — changes possible on request at any time."
            : "Müller Satelliten- und Antennentechnik GmbH · Barthelweiher 14 · 91334 Hemhofen · Germany\nTel. +49 (0) 9195 / 9404-0 · Fax +49 (0) 9195 / 9404-40 · vertrieb@satmueller.de\nKonfiguration erstellt mit dem Konfigurator auf unserer Website — Änderungen jederzeit auf Anfrage möglich.",
    };
    const doc = new jsPDF({ unit: "mm", format: "a4" });
    const now = new Date();
    const dateStr = now.toLocaleDateString("de-DE");
    const timeStr = now.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });

    doc.setFillColor(185, 28, 28);
    doc.rect(0, 0, 210, 6, "F");
    try {
        doc.addImage("/logo_pdf.jpg", "JPEG", 14, 14, 48, 30);
    } catch (e) {
        /* Logo optional */
    }
    doc.setTextColor(185, 28, 28);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text(L.title, 196, 20, { align: "right" });
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(71, 85, 105);
    doc.text(L.subtitle, 196, 27, { align: "right" });
    doc.text(L.created(`${dateStr}, ${timeStr}`), 196, 33, { align: "right" });

    doc.setTextColor(15, 23, 42);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text(L.config, 14, 56);

    autoTable(doc, {
        startY: 62,
        head: [L.head],
        body: config.map((m, i) => {
            const c = casettes[m];
            return [String(i + 1), c.sku === "—" ? "—" : c.sku, c.code, c.desc];
        }),
        theme: "grid",
        headStyles: { fillColor: [185, 28, 28], textColor: 255, fontSize: 9, fontStyle: "bold" },
        styles: { fontSize: 8.5, cellPadding: 2.2, textColor: [15, 23, 42], lineColor: [203, 213, 225], lineWidth: 0.15 },
        columnStyles: { 0: { cellWidth: 12 }, 1: { cellWidth: 22 }, 2: { cellWidth: 40 } },
        alternateRowStyles: { fillColor: [248, 250, 252] },
    });

    const after = doc.lastAutoTable ? doc.lastAutoTable.finalY : 200;
    let y = after + 14;
    if (y > 255) {
        doc.addPage();
        y = 24;
    }
    doc.setFillColor(185, 28, 28);
    doc.rect(14, y, 182, 0.8, "F");
    y += 9;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(185, 28, 28);
    doc.text(L.warranty, 14, y);
    y += 7;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(71, 85, 105);
    doc.text(L.footer, 14, y);

    const fname = `${en ? "Spec-Sheet" : "Spec-Blatt"}_${model}_${now.toISOString().slice(0, 10)}.pdf`;
    doc.save(fname);
    return fname;
}
